import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DashboardLexiData } from '../../types/dashboardLexi';
import { dashboardLexiService, type DashboardLexiParams } from './services';

export const fetchDashboardLexi = createAsyncThunk<
  DashboardLexiData,
  DashboardLexiParams | undefined,
  { rejectValue: string }
>('dashboardLexi/fetch', async (params, { rejectWithValue }) => {
  try {
    return await dashboardLexiService.get(params);
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar dashboard');
  }
});
